/**
 * Точка входа веб-клиента.
 *
 * Назначение файла: дождаться загрузки каталога переводов и только потом отрисовать
 * приложение. Порядок важен: интерфейс без текстов показал бы ключи вместо надписей.
 *
 * Импорты: React, провайдер i18next, корневой экран, глобальные стили.
 *
 * Порядок стилей важен и обратный не работает: токены объявляют переменные,
 * база пользуется ими для документа, движение — для ключевых кадров, и только
 * потом styles.css описывает экраны (docs/tech/05-web-client.md §Т5.9).
 */

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { I18nextProvider } from "react-i18next";

import { App } from "./App.jsx";
import { setupI18n } from "./i18n.js";
import { StatusPage } from "./ui/StatusPage.jsx";
import "./ui/theme/tokens.css";
import "./ui/theme/base.css";
import "./ui/theme/anim.css";
import "./styles.css";

async function bootstrap(): Promise<void> {
  const container = document.getElementById("root");
  if (!container) throw new Error("Не найден корневой элемент #root");

  const { i18n, locale } = await setupI18n();
  const path = window.location.pathname.replace(/\/$/, "") || "/";

  // Заголовок окна берётся из каталога, а не из HTML: иначе он остался бы непереведённым
  document.title =
    path === "/status" ? i18n.t("support:status.title") : i18n.t("common:app.name");

  createRoot(container).render(
    <StrictMode>
      <I18nextProvider i18n={i18n}>
        {path === "/status" ? <StatusPage locale={locale} /> : <App locale={locale} />}
      </I18nextProvider>
    </StrictMode>,
  );
}

void bootstrap();
